import Vue from 'vue';
import VueI18n from 'vue-i18n';

// Install plugin.
Vue.use(VueI18n);

export default new VueI18n({
  locale: window.localStorage.getItem('locale'),
  fallbackLocale: 'ru',
  messages: {
    en: {
      nav: {
        history: 'History',
        invoices: 'invoices',
        terminals: 'terminals',
        transfers: 'transfers',
        listOfInvoices: 'List of invoices',
        listOfTerminals: 'List of terminals',
        createNewInvoice: 'Create a new invoice',
        invoicesHistory: 'Invoices history',
        terminalsHistory: 'Terminals history',
      },
      th: {
        invoice: 'Invoice',
        date: 'Date',
        action: 'Action',
        amount: 'Amount',
        ip: 'IP',
        description: 'Description',
        insurance: 'Insurance',
        operations: 'Operations',
        cashIn: 'In',
        cashOut: 'Out',
        cashInOut: 'In-Out',
        game: 'Game',
        event: 'Event',
        value: 'Value',
        balance: 'Balance',
        credit: 'Credit',
      },
      td: {
        transfer: 'Transfer',
        transfers: 'Transfers',
        insurance: 'Insurance',
        closeInvoice: 'Close invoice',
        createInvoice: 'Create invoice',
      },
      btn: {
        save: 'Save',
        cancel: 'Cancel',
        apply: 'Apply',
      },
      lbl: {
        to: 'To',
        from: 'From',
        selectTimePeriod: 'Select time period:',
        amount: 'Amount:',
        description: 'Description:',
      },
      message: {
        club: 'club',
        logout: 'logout',
        balance: 'Balance',
        playerLockProtection: 'red background marked invoices on which there is protection from closure',
      }
    },
    ru: {
      nav: {
        history: 'История',
        invoices: 'счета',
        terminals: 'терминалы',
        transfers: 'перечисления',
        listOfInvoices: 'Список счетов',
        listOfTerminals: 'Список терминалов',
        createNewInvoice: 'Создание нового счета',
        invoicesHistory: 'История счетов',
        terminalsHistory: 'История терминалов'
      },
      th: {
        invoice: 'Счет',
        date: 'Дата',
        action: 'Действие',
        amount: 'Сумма',
        ip: 'IP',
        description: 'Примечание',
        insurance: 'Возврат',
        operations: 'Операции',
        cashIn: 'Вход',
        cashOut: 'Выход',
        cashInOut: 'Разница',
        game: 'Игра',
        event: 'Событие',
        value: 'Значение',
        balance: 'Баланс',
        credit: 'Кредит'
      },
      td: {
        transfer: 'Перечисление',
        transfers: 'Перечисления',
        insurance: 'Возврат',
        closeInvoice: 'Закрытие счета',
        createInvoice: 'Создание счета',
      },
      btn: {
        save: 'Сохранить',
        cancel: 'Отменить',
        apply: 'Применить',
      },
      lbl: {
        to: 'До',
        from: 'От',
        selectTimePeriod: 'Выберите период времени:',
        amount: 'Сумма:',
        description: 'Примечание:',
      },
      message: {
        club: 'клуб',
        logout: 'выйти из системы',
        balance: 'Баланс',
        playerLockProtection: 'красным фоном отмечены счета на которых стоит защита от закрытия',
      }
    }
  }
});
